module.exports = __webpack_public_path__ + "static/media/photo-tile-02_500.e0c3f764.jpg";